import { cn } from "@/lib/utils";
import React, { ReactNode, useState } from "react";
import { StatusOption } from "./StatusCell";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface InteractiveStatusCellProps {
  statuses: StatusOption[];
  currentStatus?: string | number;
  className?: string;
  labelClassName?: string;
  dropdownMenuItemClassName?: string;
  icon?: ReactNode;
  onStatusChange?: (newStatus: string | number) => void;
  disabled?: boolean;
}

export const InteractiveStatusCell: React.FC<InteractiveStatusCellProps> = ({
  statuses,
  currentStatus,
  className,
  labelClassName,
  dropdownMenuItemClassName,
  icon,
  onStatusChange,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  if (currentStatus === undefined || currentStatus === null) {
    return <div className={cn("text-center", className)}>-</div>;
  }

  const currentStatusOption = statuses.find((s) => s.status === currentStatus);

  if (!currentStatusOption) {
    return <div className={cn("text-center", className)}>-</div>;
  }

  const handleStatusChange = (newStatus: string | number) => {
    if (onStatusChange && !disabled) {
      onStatusChange(newStatus);
    }
    setIsOpen(false);
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
        <DropdownMenuTrigger asChild disabled={disabled}>
          <div
            className={cn(
              "min-w-20 mx-auto w-fit px-3 py-2 rounded-sm border-2 cursor-pointer hover:opacity-80 transition-opacity flex items-center justify-center gap-2",
              currentStatusOption.color,
              disabled && "cursor-not-allowed opacity-50",
              className,
            )}
          >
            <span className={cn("text-sm", labelClassName)}>
              {currentStatusOption.text}
            </span>
            {icon}
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="center" className="min-w-32">
          {statuses.map((status) => (
            <DropdownMenuItem
              key={status.status}
              onClick={() => handleStatusChange(status.status)}
              className={cn(
                "cursor-pointer justify-center",
                status.status === currentStatus && "bg-accent",
              )}
            >
              <div
                className={cn(
                  "px-3 py-1 rounded border text-sm",
                  status.color,
                  dropdownMenuItemClassName,
                )}
              >
                {status.text}
              </div>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
